export const initialChallenges = [
    {
        challengeID: '1',
        userID: '1',
        channelID: null,
        createdAt: {
            "seconds": 1727245384,
            "nanoseconds": 514000000
        },
        createdAtString: '2024-09-20',
        title: 'Hiking Challenge',
        subtitle: '3 weeks · 1 hike per week · 30 mins',
        imageURL: 'https://www.pcta.org/wp-content/uploads/2015/12/how-many-people-hike-the-pacific-crest-trail.jpg',
        videoURL: '',
        about: 'Explore the outdoors with this challenge.',
        eventTitle: 'loading',
        events: [],
        eventTime: '5 mins',
        eventsPerWeek: 1,
        weeks: 1,
        eventsTotal: 5
    }
];

export const initialAcceptedChallenges = [
    {
        challengeID: "3hXv0sJ7OrQgIfhVih6J",
        userID: "ssH2ybIWvJU5EMcJXCrkq9eVTzA2",
        acceptedID: "20240925095047ssH2yb3hXv0s",
        id: "20240925095047ssH2yb3hXv0s",
        channelID: false,
        createdAt: {
            seconds: 1727250651,
            nanoseconds: 135000000
        },
        title: "Title",
        subtitle: "3 weeks · 5 events a week · 30 min",
        imageURL: "https://media.licdn.com/dms/image/v2/C5603AQGJVLvwmULUzQ/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1516921923393?e=1732752000&v=beta&t=X_TmeJcGphKT5Q8x6nA3LT1qi9msqzcXoWYMBMItRvA",
        videoURL: "",
        about: "Testing the new funcionality.\n\nThis is a new paragraph.",
        eventTitle: "Testing",
        events: [
            1,
            1,
            1,
            "2024-09-25",
            false,
            2,
            1,
            2,
            "2024-09-26",
            false,
            3,
            1,
            3,
            "2024-09-27",
            false,
            4,
            1,
            4,
            "2024-09-28",
            false,
            5,
            1,
            5,
            "2024-09-29",
            false,
            6,
            2,
            1,
            "2024-10-02",
            false,
            7,
            2,
            2,
            "2024-10-03",
            false,
            8,
            2,
            3,
            "2024-10-04",
            false,
            9,
            2,
            4,
            "2024-10-05",
            false,
            10,
            2,
            5,
            "2024-10-06",
            false,
            11,
            3,
            1,
            "2024-10-09",
            false,
            12,
            3,
            2,
            "2024-10-10",
            false,
            13,
            3,
            3,
            "2024-10-11",
            false,
            14,
            3,
            4,
            "2024-10-12",
            false,
            15,
            3,
            5,
            "2024-10-13",
            false
        ],
        eventTime: "30 min",
        eventsTotal: 15,
        weeks: 3,
        firstDay: "2024-09-25",
        lastDay: "2024-10-13",
        doneBoolean: false
    }
]

export const initialChannels = [
    {
        channelCategory: '',
        dateJoined: 'September 23, 2024',
        facebook: '',
        twitter: '',
        youtube: '',
        instagram: '',
        id: 'Q3FsUBOI1hELc4Imu0iR',
        imageURL: 'https://firebasestorage.googleapis.com/v0/b/glu-mvp.appspot.com/o/Challenge%20Images%2Fpexels-basketball.jpg?alt=media&token=2e1fb8ea-7f0d-4d16-a750-ea881d1ef5ce',
        title: 'Basketball',
        category: 'Sports & Fitness',
        about: 'Slam dunk your way to success! Join us for fun basketball challenges, learn new skills, and show off your game. 🏀🔥',
        challenges: [
            'Dribbling Drills',
            'Free Throw Challenge',
            'Footwork Fundamentals',
            '3-Point Shooting',
            'Defensive Stance'
        ]
    },
    {
        channelCategory: '',
        dateJoined: 'September 23, 2024',
        facebook: '',
        twitter: '',
        youtube: '',
        instagram: '',
        id: '2',
        imageURL: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSVwhpOdHOvho1CiDAvkSposS5oa36_vxx--A&s',
        title: 'Yoga',
        category: 'Mind & Body Wellness',
        about: 'Find your inner peace through yoga. Join us for daily yoga challenges, learn new poses, and find your balance. 🧘‍♀️🧘‍♂️',
        challenges: [
            'Daily Sun Salutation',
            'Flexibility Focus',
            'Breathing & Meditation',
            'Beginner Poses',
            '5-Minute Desk Yoga'
        ]
    },
    {
        channelCategory: '',
        dateJoined: 'September 23, 2024',
        facebook: '',
        twitter: '',
        youtube: '',
        instagram: '',
        id: '3',
        imageURL: 'https://iso.500px.com/wp-content/uploads/2016/10/stock-photo-159358357.jpg',
        title: 'Photography',
        category: 'Creativity & Learning',
        about: "Snap, share, and challenge! Join us for daily photo adventures and fun challenges. Let's capture the world, one shot at a time. 📸✨",
        challenges: [
            'Daily Snap',
            'Rule of Thirds',
            'Golden Hour',
            'Perspective Shift',
            'Black and White Challenge'
        ]
    },
    {
        channelCategory: '',
        dateJoined: 'September 23, 2024',
        facebook: '',
        twitter: '',
        youtube: '',
        instagram: '',
        id: '4',
        imageURL: 'https://amazingfoodanddrink.com/wp-content/uploads/2023/12/Cooking-Skills-77.webp',
        title: 'Cooking',
        category: 'Food & Fun',
        about: "Spice up your kitchen with our daily cooking challenges! Learn new recipes, share your culinary creations, and join the food-loving community. 🍽️🔥",
        challenges: [
            'Recipe of the Week',
            'Healthy Ingredient Swap',
            '5-Ingredient Dishes',
            'Smoothie Creation',
            'Meal Prep Sunday'
        ]
    },
    {
        channelCategory: '',
        dateJoined: 'September 23, 2024',
        facebook: '',
        twitter: '',
        youtube: '',
        instagram: '',
        id: '5',
        imageURL: 'https://media.self.com/photos/5f75f436c78d27096dd252ca/4:3/w_2560%2Cc_limit/dancing_woman.jpeg',
        title: 'Dance',
        category: 'Fitness & Fun',
        about: 'Move your body, groove your soul! Join us for daily dance challenges, learn new styles, and share your dance moves with the world. 💃🕺',
        challenges: [
            'Dance for 10 Minutes a Day',
            'Learn a New Dance Move',
            'Choreography Challenge',
            'Dance Style Exploration',
            'Dance-Off with a Friend'
        ]
    },
    {
        channelCategory: '',
        dateJoined: 'September 23, 2024',
        facebook: '',
        twitter: '',
        youtube: '',
        instagram: '',
        id: '6',
        imageURL: 'https://yt3.googleusercontent.com/Yze4rklE8CTPlzFXUsBOdyk_p5z_ezvAL8XaxVWzcYKwLeJn8pEJdgZweGPPHebkOeevVZVzMQQ=s900-c-k-c0x00ffffff-no-rj',
        title: 'Meditation',
        category: 'Mind & Relaxation',
        about: 'Find inner peace and tranquility. Join us for daily meditation challenges, learn new techniques, and cultivate mindfulness in your life. 🧘‍♂️🧘‍♀️',
        challenges: [
            '5-Minute Meditation',
            'Guided Meditation',
            'Nature Sounds Meditation',
            'Gratitude Meditation',
            'Mindful Walking'
        ]
    },
    {
        channelCategory: '',
        dateJoined: 'September 23, 2024',
        facebook: '',
        twitter: '',
        youtube: '',
        instagram: '',
        id: '7',
        imageURL: 'https://mendhamgardencenter.com/wp-content/uploads/2022/03/istockphoto-1161321111-612x612-2.jpg',
        title: 'Gardening',
        category: 'Outdoor & Nature',
        about: 'Grow your garden, nurture your soul. Join us for daily gardening challenges, learn new tips and tricks, and share your plant creations. 🌿🌱',
        challenges: [
            'Daily Plant Care',
            'Seed Planting',
            'Composting Challenge',
            'Nature Journal',
            'Create a Mini Herb Garden'
        ]
    },
    {
        channelCategory: '',
        dateJoined: 'September 23, 2024',
        facebook: '',
        twitter: '',
        youtube: '',
        instagram: '',
        id: '8',
        imageURL: 'https://www.kitzbuehel.com/fileadmin/_processed_/7/4/csm_Rennrad_Fr%C3%BChling_Kitzb%C3%BChel__c__Kitzb%C3%BChel_Tourismus_-_Thomas_Griesbeck__2__86fe21c4a7.jpg',
        title: 'Cycling',
        category: 'Outdoor Fitness',
        about: 'Explore the world on two wheels! Join us for daily cycling challenges, learn new routes, and share your cycling adventures. 🚴‍♀️🚴‍♂️',
        challenges: [
            'Daily Ride',
            'Speed Challenge',
            'Hill Climbing',
            'Scenic Route',
            'Biking Buddy'
        ]
    },
    {
        channelCategory: '',
        dateJoined: 'September 23, 2024',
        facebook: '',
        twitter: '',
        youtube: '',
        instagram: '',
        id: '9',
        imageURL: 'https://www.pictoclub.com/wp-content/uploads/2021/09/painting-brushes-scaled.jpg',
        title: 'Art & Drawing',
        category: 'Creativity & Fun',
        about: 'Unleash your inner artist! Join us for daily art and drawing challenges, learn new techniques, and share your masterpieces. 🎨🖌️',
        challenges: [
            'Daily Doodle',
            'Sketchbook Exploration',
            '3-Color Challenge',
            'Portrait Practice',
            'Drawing Prompts'
        ]
    },
    {
        channelCategory: '',
        dateJoined: 'September 23, 2024',
        facebook: '',
        twitter: '',
        youtube: '',
        instagram: '',
        id: '10',
        imageURL: 'https://i0.wp.com/www.muscleandfitness.com/wp-content/uploads/2018/07/1109-home-workout0.jpg?quality=86&strip=all',
        title: 'Fitness at Home',
        category: 'Fitness & Wellness',
        about: 'Get fit from the comfort of your own home! Join us for daily fitness challenges, learn new workouts, and achieve your fitness goals. 💪🏠',
        challenges: [
            '10-Minute Workouts',
            'Strength Challenge',
            'HIIT Sessions',
            'Push-Up Progress',
            'Plank Hold'
        ]
    },
    {
        channelCategory: '',
        dateJoined: 'September 23, 2024',
        facebook: '',
        twitter: '',
        youtube: '',
        instagram: '',
        id: '11',
        imageURL: 'https://i0.wp.com/images-prod.healthline.com/hlcmsresource/images/topic_centers/2019-8/couple-hiking-mountain-climbing-1296x728-header.jpg?w=1155&h=1528',
        title: 'Hiking',
        category: 'Outdoor & Adventure',
        about: 'Conquer new heights! Join us for daily hiking challenges, discover breathtaking trails, and share your outdoor adventures. 🥾🌄',
        challenges: [
            'Weekly Hike',
            'Step Count',
            'Elevation Gain',
            'Nature Journaling',
            'Hiking Buddy'
        ]
    }
];

export const initialTags = [
    "Hobbies",
    "Diet",
    "Growth",
    "Fitness",
    "Yoga",
    "Community",
    "Family",
    "Finances",
    "Meditation",
    "Self Care"
];

const initialChannelsNew = [
    // {
    //     userID
    //     createdAt
    //     title
    //     subtitle
    //     imageURL
    //     about
    //     channelWebsiteTitle
    //     channelWebsiteURL
    //     channelWebsiteImageURL
    //     youtube
    //     facebook
    //     instagram
    //     twitter
    // }
]

const loadingObject = {
    challengeID: '1',
    userID: '1',
    channelID: false,
    createdAt: 'timestamp',
    createdAtString: '2024-09-20',
    title: 'Hiking Challenge',
    subtitle: '3 weeks · 1 hike per week · 30 mins',
    imageURL: 'https://www.pcta.org/wp-content/uploads/2015/12/how-many-people-hike-the-pacific-crest-trail.jpg',
    videoURL: '',
    about: 'Explore the outdoors with this challenge.',
    eventTitle: 'loading',
    eventsArray: [],
    eventTime: '5 mins',
    eventsPerWeek: 1,
    weeks: 1,
    eventsTotal: 5
}